import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import cookies from 'vue-cookies'

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.params = {}
axios.interceptors.request.use(
  request => {
    let accept_language =
      request && request.headers && request.headers[ 'accept-language' ]
        ? request.headers[ 'accept-language' ]
          .split(',')[ 0 ]
          .toLocaleLowerCase()
          .substring(0, 2)
        : process.env.VUE_APP_DEFAULT_LANGUAGE,
      lang = cookies.get('wegow.i18n-lang') || accept_language,
      access_token = $cookies.get('wegow.access_token'),
      refresh_token = $cookies.get('wegow.refresh_token')
    if (typeof refresh_token !== 'undefined' && refresh_token !== null && typeof access_token !== 'undefined' && access_token !== null) {
      request.headers.common.Authorization = `Bearer ${access_token}`
    }
    request.params = request.params || {}
    request.headers.common[ 'Accept-Language' ] = lang

    request.params.mongo = true
    return request
  },
  function(error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  res => {
    return Promise.resolve(res)
  },
  function(error) {
    if (error && error.response && error.response.status && error.response.status === 401 && $cookies.get('wegow.refresh_token')) {
      return (
        axios
          .post(`/jwt/token/refresh/`, {
            refresh: $cookies.get('wegow.refresh_token')
          })
          .then(res => {
            $cookies.set('wegow.access_token', res.data.access_token)
            $cookies.set('wegow.expiry_token', res.data.expiry_token)
            error.response.config.headers.Authorization = `Bearer ${res.data.access_token}`
            return axios.request(error.response.config)
          })
          // Would be nice to catch an error here, which would work, if the interceptor is omitted
          .catch(err => err)
      )
    } else if (error.response.status === 403) {
      $cookies.remove('wegow.access_token')
      $cookies.remove('wegow.refresh_token')
      $cookies.remove('wegow.expiry_token')
    }

    return Promise.reject(error.response)
  }
)

Vue.use(VueAxios, axios)
